import type { Orientation } from "../types.ts";
import { customDevice } from "./devices.ts";

const extent = 16384;
export const canvasBackgroundExtents = { width: extent, height: extent };
export const canvasTransformOrigin = `${canvasBackgroundExtents.width / 2}px ${canvasBackgroundExtents.height / 2}px`;

export const getCanvasOrientation = (width: number, height: number): Orientation =>
  width >= height ? "horizontal" : "vertical";

export const defaultCanvasState = {
  x: 0,
  y: 0,
  scale: 1,
  transformOrigin: canvasTransformOrigin,
  opacity: 0,
  canvasTop: "0",
  canvasLeft: "0",
  backgroundTop: "0",
  backgroundLeft: "0",
  screenshot: "",
  ...customDevice,
};

export type CanvasStickyState = typeof defaultCanvasState;
